/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2014, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Class',
	'jquery',
	'underscore'
], function(Class, $, _) {

	/**
	 * This class provides common functions for single select controls which mixes in or sub-classing.
	 *
	 *	Common properties:
	 *		- collapsedItemMap: {}
	 *
	 *	Common functions:
	 *		- renderCollapsed
	 *		- updateMenuItemTick
	 *
	 *	Abstract function:
	 *		- updateSelectedItemInHamburgerMenu: renderCollapsed function invokes this function
	 *
	 */
	var CollapsibleItem = Class.extend({
		collapsedItemMap: {},
		_rootMenu: null,
		_bCollapsedRenderDone: false,

		/**
		 * Creates a new item
		 *
		 * @param spec -
		 *            The item spec
		 * @param root -
		 *            A reference to the root menu item, where items go if the app bar is collapsed horizontally
		 */
		init: function(spec, root) {
			_.extend(this, spec);
			CollapsibleItem.inherited('init', this, arguments);
			this._rootMenu = root;
			this._bCollapsedRenderDone = false;
		},

		/**
		 * Populates menu items under _rootMenu only once.
		 */
		renderCollapsed: function() {
			if (!this._bCollapsedRenderDone) {
				//Add section in root menu
				var divider = $('<li role="presentation" class="divider visible-xs header-' + this.name + '"/>');

				// Don't add a second divider if there is a divider already
				if (!this._rootMenu.$menu.children().last().hasClass('divider')) {
					this._rootMenu.$menu.append(divider);
				}

				var _rootMenuHeader = $('<li role="presentation" class="dropdown-header visible-xs header-' + this.name + '">' + this.label + '</li>');
				this._rootMenu.$menu.append(_rootMenuHeader);

				var sCheckedItem = null;

				if (this.items) {
					_.each(this.items, (subItem) => {
						if (subItem.checked && !sCheckedItem) {
							sCheckedItem = subItem.name;
						} else {
							//Only one item should have checked specified. Ignore
							subItem.checked = false;
						}

						//Assign updateSelectedItemInHamburgerMenu function as action of menu item
						var clonedItem = _.clone(subItem);
						clonedItem._action = clonedItem.action;

						clonedItem.action = () => {
							this.updateSelectedItemInHamburgerMenu(clonedItem.name);
						};

						var menuItem = this._rootMenu.addItem(clonedItem);
						menuItem.addClass('visible-xs');

						//Save menu item
						this.collapsedItemMap[clonedItem.name] = menuItem;
					});

					if (!sCheckedItem) { //Check first item if not specified
						var jFirstItem = this.items[0];
						this.updateSelectedItemInHamburgerMenu(jFirstItem.name);
					}
				}

				this._rootMenu.$menu.append(divider);
				this._bCollapsedRenderDone = true;
			}
		},

		/**
		 * Updates checked mark and aria-checked attributes in given menuItem
		 */
		updateMenuItemTick: function($MenuItem, checked) {
			if ($MenuItem) {
				let item = $MenuItem.find('a');

				item.toggleClass('menuitem-toggled', checked);
				item[0].setAttribute('aria-checked', checked ? 'true' : 'false');
			}
		},

		/**
		 * Abstract - Subclass must implement
		 */
		updateSelectedItemInHamburgerMenu: function (name) {
			return name;
		},

		remove: function() {
			_.each(this.collapsedItemMap, (item) => {
				if (item.remove) {
					item.remove();
				}
			});
		}
	});

	return CollapsibleItem;
});
